import { call, put, takeLatest } from "redux-saga/effects"
import * as api from "./api"

// Bookings Redux States
import {
  GET_BOOKINGS,
  GET_BOOKING_DETAILS,
} from "./actionTypes"
import {
  apiError,
  getBookingsSuccess,
  getBookingDetailsSuccess,
} from "./actions"


function* getBookings({ filters, options }) {
  try {
    const { data } = yield call(api.getBookings, filters, options)
    yield put(getBookingsSuccess(data))
  } catch (error) {
    yield put(apiError(error))
  }
}

function* getBookingDetails({ payload: { id } }) {
  try {
    let response
    if (id !== "empty") {
      response = yield call(api.getBookingDetails, id)
    }
    yield put(getBookingDetailsSuccess(id === "empty" ? [] : response?.data))
  } catch (error) {
    yield put(apiError(error))
  }
}

function* eventsSaga() {
  // These mutually exclusive routes share the same read status.
  yield takeLatest([GET_BOOKINGS, GET_BOOKING_DETAILS], function* (action) {
    yield* (action.type === GET_BOOKINGS ? getBookings(action) : getBookingDetails(action))
  })
}

export default eventsSaga
